import { render, staticRenderFns } from "./aliBill.vue?vue&type=template&id=63e8093c&"
import script from "./aliBill.vue?vue&type=script&lang=js&"
export * from "./aliBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports